import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=7ec99933&scoped=true"
import script from "./Departures.js?vue&type=script&lang=js&external"
export * from "./Departures.js?vue&type=script&lang=js&external"
import style0 from "./Departures.vue?vue&type=style&index=0&id=7ec99933&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec99933",
  null
  
)

export default component.exports